<template>
  <div class="row">
    <div class="col-1 p-0 text-white d-flex justify-content-center mr-n5">
      <div
        class="question-section question-order text-center d-flex justify-content-center align-items-center font-weight-bold"
      >
        <span class="question-number">
          {{ numberLabel | extractNumber }}
        </span>
        <sup class="question-number-sup">
          {{ numberLabel | extractLetter }}
        </sup>
      </div>
    </div>
    <div class="col-6 col-sm col-12">
      <p class="mb-0 question-description ml-2">
        <span class="question-title">{{ text }}</span>
      </p>
    </div>
    <div class="col-5 text-right p-0">
      <ValidationProvider v-slot="{ errors }" rules="required">
        <div class="pagination mb-2 float-right mr-3">
          <error
            v-if="errors.length > 0"
            :message="errorMessage"
            is-borderless
            style="left: 12.8em; top: 2.6em; padding-bottom: 22px;"
          />
          <div
            v-for="(item, index) in scales"
            :key="'scale_' + index"
            class="page-item custom-page-item"
            :class="{ 'has-error': errors.length > 0, 'read-mode': disabled }"
          >
            <div class="page-link page-link-custom">
              <span class="d-block text-center text-dark">
                {{ item.text }}
              </span>
              <div class="input-group text-center">
                <input
                  :id="'scale_' + id + '_' + item.id"
                  :key="'scale_' + id + '_' + item.id"
                  v-model="value"
                  type="radio"
                  class="hidden"
                  required
                  :name="'scale_' + id"
                  :value="item"
                  :disabled="disabled"
                />
                <label class="entry" :for="'scale_' + id + '_' + item.id">
                  <div class="circle selected-position" />
                  <div class="entry-label" />
                </label>
                <div
                  v-if="item.id == selectedNumericAnswerId"
                  :class="{ highlight: item.id == selectedNumericAnswerId }"
                  class="selected-position"
                />
              </div>
            </div>
          </div>
        </div>
      </ValidationProvider>
    </div>
  </div>
</template>

<style>
.question-section.question-order {
  background-color: #ff7058;
  color: white;
}
.question-section {
  width: 60px;
  min-height: 60px;
  border-radius: 5px 5px 0px 0px;
  font: 20px Lato;
}
.question-section.active {
  background-color: #2db782;
}
.question-section {
  background-color: #f2f2f2;
  color: #c9c9c9;
}
.question-answer {
  cursor: pointer;
}
.question-description {
  font: 18px Lato;
  padding-top: 6px;
}
.page-link-custom {
  line-height: 4px;
  padding-top: 15px;
}
.page-link-custom:hover {
  background: transparent;
}
.selected-position {
  margin-left: 4px;
  margin-top: 10px;
}
.custom-page-item {
  width: 52px;
}

@media only screen and (max-width: 768px) {
  .question-description {
    margin-left: 50px !important;
  }
}

.page-item.has-error:last-child .page-link {
  border-right: 1px solid red;
}
.page-item.has-error .page-link {
  border: 1px solid red;
  border-right: none;
}
.page-item.read-mode:last-child .page-link {
  border-right: 1px solid #cfd0d1;
}
.read-mode .page-link {
  background: #f8f8f8;
  border: 1px solid #cfd0d1;
  border-right: none;
}
.read-mode,
.read-mode .input-group .circle {
  cursor: not-allowed;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate';
import Error from '@/components/common/Error.vue';

export default {
  name: 'ScaleQuestion',
  components: {
    ValidationProvider,
    Error,
  },
  filters: {
    extractNumber(value) {
      return value.slice(0, 1);
    },
    extractLetter(value) {
      function evalLetter(letter) {
        switch (letter) {
          case 'a':
            return '1';
          case 'b':
            return '2';
          case 'c':
            return '3';
          default:
            return '';
        }
      }
      let letter = value.slice(2, value.length - 1);
      let n = evalLetter(letter);
      return n;
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      default: () => '',
    },
    text: {
      type: String,
      default: () => '',
    },
    numberLabel: {
      type: String,
      default: () => '',
    },
    scales: {
      type: Array,
      default: () => [{ id: 0, text: '1', isSelected: false }],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'El campo es obligatorio.',
    },
  },
  computed: {
    selectedNumericAnswerId() {
      const id = this.value?.id;
      return id;
    },
  },
  watch: {
    selectedNumericAnswerId(idSelected) {
      this.$emit('onSelectedNumericAnswer', idSelected);
      this.$emit('input', this.value);
    },
  },
};
</script>
